// extracted by mini-css-extract-plugin
module.exports = {"link":"sociallinks_link___y5xV","icon":"sociallinks_icon__5_IYF"};